export default __webpack_public_path__ + "static/media/star.7127a155.svg";